
import { SectionOrFilter } from "../filterTypes"
import { messages } from "./messages"

//Fields that you can search by keyword on the search input.
export const paymentsListFields = [
    "identifier",
    "identifierAnalyzed",
    "identifierNumber", //This field affects the search by payment identifier on elastic-v8 (it does not work)
    "identifierKeyword",
    "notes",
]

export const paymentsListTotals = [
    "paymentAmount"
]

export const getPaymentsFilters = (context) => {
    
    const availableFilters: SectionOrFilter[] =
        [
            {
                nameId: "paymentStatus",
                label: context.intl?.formatMessage(messages["payment_status"]),
                type: "select",
                filterMatch: "paymentStatus", 
                typeOfSelect: "payment-status-select",
                placeHolder: context.intl?.formatMessage(messages["payment_status"]),
                initialValue: [],
                initialSelect: "isOneOf"
            },
            {
                nameId: "paymentType",
                label: context.intl?.formatMessage(messages["payment_type"]),
                filterMatch: "paymentTypeId",
                type: "select",
                typeOfSelect: "payment-type-select",
                initialValue: "",
                initialSelect: "isOneOf"
            },
            {
                nameId: "paymentSource",
                label: context.intl?.formatMessage(messages["payment_source"]),
                filterMatch: "paymentSource", 
                type: "select",
                typeOfSelect: "payment-source-select",
                initialValue: "",
                initialSelect: "isOneOf"
            },
            {
                nameId: "paymentAmount",
                label: context.intl?.formatMessage(messages["payment_amount"]),
                nameField: "paymentAmount",
                filterMatch: "paymentAmount",
                type: "number",
                initialValue: "",
                initialSelect: "is"
            },
            {
                nameId: "paymentNote",
                label: context.intl?.formatMessage(messages["payment_note"]),
                filterMatch: "notes",
                type: "text",
                initialValue: "",
                initialSelect: "is"
            },
            {
                nameId: "paymentCurrency",
                label: context.intl?.formatMessage(messages["payment_currency"]),
                filterMatch: "paymentCurrency",
                type: "select",
                typeOfSelect: "currency-select",
                initialValue: [],
                initialSelect: "isOneOf"
            }, 
            {
                nameId: "paymentCapturedAt",
                label: context.intl?.formatMessage(messages["payment_captured_at"]),
                filterMatch: "capturedAtDate",
                type: "date",
                initialValue: {startDate: null, endDate: null},
                initialSelect: "is"
            },
            {
                nameId: "paymentVoidedAt",
                label: context.intl?.formatMessage(messages["payment_voided_at"]),
                filterMatch: "voidedAt",
                type: "date",
                initialValue: {startDate: null, endDate: null},
                initialSelect: "is"
            },
            {
                nameId: "integrationKey",
                label: context.intl?.formatMessage(messages["integration_key"]),
                filterMatch: "integrationKey",
                type: "text",
                initialValue: "",
                initialSelect: "is"
            },
            {
                nameId: "data3DSStatus",
                label: context.intl?.formatMessage(messages["data_3ds_status"]),
                filterMatch: "data3DSStatus",
                type: "select",
                typeOfSelect: "payment-3ds-status-select",
                initialValue: "",
                initialSelect: "isOneOf"
            },
            {
                nameId: "data3DSRequested",
                label: context.intl?.formatMessage(messages["data_3ds_requested"]),
                filterMatch: "data3DSRequested",
                type: "boolean",
                initialValue: "",
                initialSelect: "is"
            },
            {
                nameId: "data3DSFailedReason",
                label: context.intl?.formatMessage(messages["data_3ds_failed_reason"]),
                filterMatch: "data3DSFailedReason",
                type: "text",
                initialValue: "",
                initialSelect: "is"
            },
        ]
    return availableFilters
}


// WEBPACK FOOTER //
// ./src/common/search-filter/search/paymentFilters/paymentsFilters.ts